import React, { Fragment, useState } from 'react'
import { withErrorBoundary, ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
import { useNotify } from '../../../Project/hooks/useNotify'
import { IconSvg } from '../../../SVG/Icons'
import { logError } from '../../../../lib/error-logger'
import { useLocation } from '../../../../hooks/useLocation'
import { useSelector } from 'react-redux'

function ErrorFallback({ error }) {
  const loc = useLocation()
  const isPreview = !String(loc.pathname).startsWith('/project') && !loc.search.includes('ftnocache')
  return isPreview ? (
    <div className="ft-error-alert" role="error">
      <p>
        <IconSvg type="ErrorNotify" className="icon" />
        Oops something went wrong, please contact support.
      </p>
    </div>
  ) : null
}

export const withCustomErrorBoundary = (Component, ComponentName = '') => {
  return withErrorBoundary(Component, {
    FallbackComponent: ErrorFallback,
    onError(error, info) {
      // Do something with the error
      // E.g. log to an error logging client here
      if (typeof window.__FT_PROJECT__API__?.FTExtendDebugInfo === 'function') {
        logError(
          'ErrorBoundary',
          error,
          window.__FT_PROJECT__API__.FTExtendDebugInfo({
            component: ComponentName,
          })
        )
      } else {
        logError('ErrorBoundary', error, {
          component: ComponentName,
        })
      }
      console.error(error, info)
    },
  })
}

export const ErrorBoundary = ({ children, errorChildren, isHideError = false, isHideConsole = false, name }) => {
  const { notify } = useNotify()
  const pageID = useSelector((state) => state.get('page'))
  const device = useSelector((state) => state.get('layoutMode', 'lg'))
  const projectID = useSelector((state) => state.getIn(['project', '_id']) || null)
  const [isRenderError, setIsRenderError] = useState(false)
  if (isRenderError && errorChildren) {
    return errorChildren
  }

  return (
    <ReactErrorBoundary
      FallbackComponent={isHideError ? () => null : ErrorFallback}
      onError={(error, info) => {
        setIsRenderError(true)
        // Do something with the error
        // E.g. log to an error logging client here
        if (!isHideConsole) {
          notify('Oops something went wrong, please contact support.', 'error')
          console.error(error, info)
          logError('ErrorBoundary', error, {
            pageID,
            device,
            projectID,
            info,
            name,
          })
        }
      }}>
      {children}
    </ReactErrorBoundary>
  )
}
